var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.files && _vm.files.length
    ? _c(
        "div",
        _vm._l(_vm.files, function(file) {
          return _c("div", { key: file.name }, [
            _c(
              "a",
              { attrs: { href: file.url, target: "_blank", download: "" } },
              [_vm._v("\n      " + _vm._s(file.name) + "\n    ")]
            )
          ])
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c7726d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c7726d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/file/file-link-list.vue
// module id = null
// module chunks = 